import { ProCompanies } from './ProCompanies'
import './ProUsageDashboard.css'

/**
 * Skida PRO: the companies using it, and how far each has got.
 *
 * ## One picture — 21 Oct 2026
 *
 * The cards on top used to count seats off `skidaCrmLeads` while the table
 * below read the companies from the product project, so the two described
 * different populations and rarely agreed. The cards are now the companies
 * table's own state counts (`proCompanyState.ts`) — signed in, registered,
 * trial, signed up, abandoned — rendered by `ProCompanies` from the rows it
 * shows, and pressing one filters the table to it.
 *
 * Everything that sat under the table went at the same time: the period row,
 * the "not recorded" strip, the seat goal and the top-companies list. All of it
 * was the lead-based reading this screen no longer makes.
 */
export function ProUsageDashboard() {
  return (
    <div className="dash">
      <h2 className="dash__title" data-onb="pro-header">Skida PRO usage dashboard</h2>
      <p className="dash__lede">Every company in Skida PRO, and how far each has got.</p>
      <ProCompanies />
    </div>
  )
}
